import { Component, OnInit } from '@angular/core';
import { PhotoViewerService } from '@shared/services/photo-viewer/photo-viewer.service';
import { environment } from '@env/environment';

@Component({
  selector: 'photo-viewer',
  templateUrl: './photo-viewer.component.html',
  styleUrls: ['./photo-viewer.component.scss']
})
export class PhotoViewerComponent implements OnInit {
  constructor(private _photoViewerService: PhotoViewerService) {}
  imageUrl;
  baseUrl = environment.baseUrl;
  ngOnInit() {
    this._photoViewerService.image.subscribe(image => {
      this.imageUrl = image;
    });
  }

  closeImageViewer() {
    this._photoViewerService.toggle();
  }
}
